import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FantasyGameDetailsV2, FantasyGameService, FantasyGameV2 } from '@fgb/core';

import * as _moment from 'moment';
const moment = _moment;

@Component({
  selector: 'fgb-fantasy-game-panel',
  templateUrl: './fantasy-game-panel.component.html',
  styleUrls: ['./fantasy-game-panel.component.scss'],
})
export class FantasyGamePanelComponent implements OnChanges {
  @Input() games: FantasyGameV2[] = [];
  @Input() isFutureGame: boolean = false;

  gameEnds: boolean = false;

  gameDate: string;
  gameTime: string;
  gameDetails: FantasyGameDetailsV2;

  private lastGameId: number | null = null;

  constructor(private fantasyGameService: FantasyGameService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.games || !this.games?.length) {
      return;
    }

    const gameId = this.games[0].GameId;

    // Fetch details only once per game
    if (this.lastGameId !== gameId) {
      this.lastGameId = gameId;

      this.fantasyGameService.fetchGameDetailsV2(gameId).subscribe((details) => {
        this.gameDetails = details;
      });
    }

    this.games = this.games.map((game) => ({
      ...game,
      GameDateOnly: moment.utc(game.GameDate).local().format('ddd DD MMM'),
      GameTimeOnly: moment.utc(game.GameDate).local().format('H:mm'),
    }));

    this.gameDate = moment.utc(this.games[0].GameDate).local().format('ddd DD MMM');
    this.gameTime = moment.utc(this.games[0].GameDate).local().format('H:mm');
  }

  onGameEnds(event: any) {
    this.gameEnds = event;
  }
}
